<template>
  <v-container class="py-12">
    <div class="text-center mb-12">
      <h1 class="text-h4 text-sm-h3">Mon profil</h1>

      <div class="subtitle-1 text--secondary mt-2">
        Consultez ou modifiez vos informations personnelles
      </div>
    </div>

    <template v-if="$store.state.user">
      <profile-infos :countries="countries"></profile-infos>

      <profile-contact class="mt-12"></profile-contact>

      <profile-address class="mt-12" :countries="countries"></profile-address>
    </template>
  </v-container>
</template>

<script>
import ProfileInfos from '@/components/profile/ProfileInfos.vue';
import ProfileContact from '@/components/profile/ProfileContact.vue';
import ProfileAddress from '@/components/profile/ProfileAddress.vue';

const axios = require('axios').default;

export default {
  name: 'Profile',

  components: {
    'profile-infos': ProfileInfos,
    'profile-contact': ProfileContact,
    'profile-address': ProfileAddress,
  },

  data: () => ({
    countries: [],
  }),

  created() {
    this.getCountries();
  },

  methods: {
    async getCountries() {
      try {
        const response = await axios.get('countries');
        this.countries = response.data;
      } catch (error) {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Une erreur est survenue, rechargez la page',
        });
      }
    },
  },
};
</script>
